'use client';
import { useRef, useState, SetStateAction, Dispatch, ReactNode } from 'react';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import './wizard.css';

export interface WizardProps {
  overideSlide?: number;
  children: ({
    currentSlide,
    setCurrentSlide,
  }: {
    currentSlide: number;
    setCurrentSlide: Dispatch<SetStateAction<number>>;
  }) => ReactNode;
}

export function Wizard({ children, overideSlide }: WizardProps) {
  const [currentSlide, setCurrentSlide] = useState<number>(overideSlide || 0);
  const ref = useRef<HTMLDivElement>(null);

  return (
    <SwitchTransition>
      <CSSTransition
        key={currentSlide}
        addEndListener={(done) => {
          if (ref.current) {
            ref.current.addEventListener('transitionend', done, false);
          }
        }}
        classNames="fade"
        nodeRef={ref}
      >
        <div ref={ref}>{children ? children({ currentSlide, setCurrentSlide }) : null}</div>
      </CSSTransition>
    </SwitchTransition>
  );
}
